import React from 'react';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AGTEnhanceButton = ({
  onEnhance,
  isLoading,
  disabled = false,
  label,
  tooltip,
  icon = <Sparkles size={20} />,
  sx = {}
}) => {
  const { t } = useTranslation();
  
  // Use provided label/tooltip or default translation
  const buttonLabel = label || t('agtUps.productsManager.enhanceButton.enhanceWithAGT');
  const buttonTooltip = tooltip || t('agtUps.productsManager.enhanceButton.enhanceTooltip');

  return (
    <Tooltip title={buttonTooltip} arrow placement="top">
      <span>
        <Button
          variant="outlined"
          startIcon={isLoading ? <CircularProgress size={20} /> : icon}
          onClick={onEnhance}
          disabled={disabled || isLoading}
          sx={{
            textTransform: 'none',
            fontWeight: 500,
            borderRadius: '28px',
            color: (theme) => theme.palette.actualMode === 'wallpaper' ? '#FFFFFF' : '#0385FF',
            borderColor: (theme) => theme.palette.actualMode === 'wallpaper' ? '#FFFFFF' : '#0385FF',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: (theme) => theme.palette.actualMode === 'wallpaper'
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(3,133,255,0.08)',
              borderColor: (theme) => theme.palette.actualMode === 'wallpaper' ? '#E0E0E0' : '#0266cc'
            },
            ...sx
          }}
        >
          {buttonLabel}
        </Button>
      </span>
    </Tooltip>
  );
};

export default AGTEnhanceButton;